import * as _4 from 'lodash4';
import { Datasource, IDatasource } from 'utility-ng-kernel';
import { Metasource } from 'utility-ts-datasource';
import { IAPProgramSlotDatasource } from '../../../../global/datasources/ap_program_slot_datasource';
import { IPlanFeedbackCourseMeta, PlanFeedbackCourse } from '../builders/plan_feedback_course_builder';
import { fillTermInfo } from './plan_feedback_course_groups_datasource';
import { IPlanFeedbackProgramSlotsDatasource } from './plan_feedback_program_slots_datasource';
import { IPlanFeebackTermsDatasource } from './plan_feedback_terms_datasource';

export interface IPlanFeebackCoursesDatasource extends IDatasource<PlanFeedbackCourse, {}, IPlanFeedbackCourseMeta> {}

angular
  .module('capability-ng-academic-planner')
  .factory(
    'ngPlanFeebackCoursesDatasource',
    (
      ngPlanFeebackTermsDatasource: IPlanFeebackTermsDatasource,
      ngPlanFeedbackProgramSlotsDatasource: IPlanFeedbackProgramSlotsDatasource,
      ngAPProgramSlotDatasource: IAPProgramSlotDatasource
    ) =>
      new Datasource<PlanFeedbackCourse>({
        builderType: PlanFeedbackCourse
      }).includeMetasource<IPlanFeedbackCourseMeta>((datasource) => {
        return new Metasource<PlanFeedbackCourse, IPlanFeedbackCourseMeta>(datasource)
          .includeAttribute('_from_term', (feedbackCourse) =>
            fillTermInfo(ngPlanFeebackTermsDatasource, 'from_term', feedbackCourse)
          )
          .includeAttribute('_term', (feedbackCourse) =>
            fillTermInfo(ngPlanFeebackTermsDatasource, 'term', feedbackCourse)
          )
          .includeAttribute('_programSlot', (feedbackCourse) =>
            _4.find(ngAPProgramSlotDatasource.metasource().derived(), {
              id: feedbackCourse['program_slot']
            })
          )
          .includeAttribute('_feedbackProgramSlot', (feedbackCourse) =>
            _4.first(
              ngPlanFeedbackProgramSlotsDatasource.query((p) => p.program_slot === feedbackCourse['program_slot'])
            )
          );
      })
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/suggestions/components/plan_feedback/datasources/plan_feedback_courses_datasource.ts